import React, { Component } from "react";
import { isPortrait } from "../assets/javascript/utils";

import Header from "../components/Header/Header";

export default class SolarSystemView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasLoaded: false,
      canActivateAR: false,
      isArSupported: false,
    };

    this.arButtonRef = React.createRef();
    this.modelViewerRef = React.createRef();
  }

  componentDidMount() {
    const _canActivateAR =
      this.modelViewerRef.current.getAttribute("canactivatear") === "true";

    if (_canActivateAR) {
      document.querySelectorAll("html")[0].classList.add("-ar-enabled");
    }

    this.setState({
      canActivateAR: _canActivateAR,
    });

    this.modelViewerRef.current.addEventListener("load", () => {
      this.setState({
        hasLoaded: true,
      });
    });

    if (navigator.xr) {
      navigator.xr.isSessionSupported("immersive-ar").then((isSupported) => {
        this.setState({
          isArSupported: isSupported,
        });
      });
    }
  }

  componentWillUnmount() {
    this.modelViewerRef.current.removeEventListener("load", () => {
      this.setState({
        hasLoaded: true,
      });
    });
  }

  render() {
    const { hasLoaded, canActivateAR, isArSupported } = this.state;

    return (
      <div className="solarSystemOrbit">
        <Header />

        <div className="container">
          <button
            className="info__model"
            type="button"
            onClick={() => {
              if (isArSupported && hasLoaded && canActivateAR && isPortrait()) {
                this.arButtonRef.current.click();
              } else if (!isArSupported) {
                window.location = "/telescope/";
              }
            }}>
            <model-viewer
              ref={this.modelViewerRef}
              src={`/assets/models/solar-system/source/solar-system.glb`}
              alt={`A 3D model of the Solar System`}
              ar
              ar-scale="auto"
              autoplay
              auto-rotate-delay="0"
              ar-modes="scene-viewer quick-look" // * Values: webxr scene-viewer quick-look
              seamless-poster
              shadow-intensity="0"
              loading="lazy"
              canActivateAR>
              <div
                slot="ar-button"
                ref={this.arButtonRef}
                style={{ display: "none" }}>
                View in 3D
              </div>
            </model-viewer>
          </button>
        </div>
      </div>
    );
  }
}
